export default [
  'default',
  'animal',
  'bicycle',
  'boat',
  'bus',
  'car',
  'camper',
  'crane',
  'helicopter',
  'motorcycle',
  'person',
  'plane',
  'ship',
  'tractor',
  'trailer',
  'train',
  'tram',
  'truck',
  'van',
  'scooter',
];
